import {isNilOrEmpty, isTrue} from 'ramda-adjunct';

export const getIfIsFeatureHidden = (feature?: string | null) =>
  isTrue(feature === 'false') || isNilOrEmpty(feature);
